import requests from "./httpService";
const MembershipListServices = {
    getMembership: async () => {
        return requests.get(`/membership`);
    },
    getMembershipCategory: async () => {
        return requests.get(`/membership-category/guest/membership-category`);
    },
    updateMembership: async (id, body) => {
     return requests.patch(`/membership/${id}`, body);
    },
    updateMemberships: async (id, body) => {
        return requests.put(`/membership/${id}`, body);
    },
    createMembership: async (body) => {
        return requests.post(`/membership`, body);
    },
    deleteMembership: async (id) => {
        return requests.delete(`/membership/${id}`);
    },
 membershipServiceCategory: async (id) => {
    return requests.post(`/membership/membership-service-category-admin`, {
        categoryId: id  
    });
}
}
export default MembershipListServices;